// extracted by mini-css-extract-plugin
export default {"container":"BackBtn_container__EO8Pq","wrapper":"BackBtn_wrapper__8NEv9","text":"BackBtn_text__zOH25"};